(function () {
  var header = document.querySelector('.header-v6');
  if (!header) return;

  // 只在首页生效
  var isHome = document.body.classList.contains('index') 
    || window.location.pathname === '/';
  if (!isHome) return;

  var THRESHOLD = 20;

  function update() {
    if (window.scrollY <= THRESHOLD) {
      header.classList.add('header-v6--hero');
    } else {
      header.classList.remove('header-v6--hero');
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();